import { network } from 'services/network';

export const getCardDates = (params) => {
    return network.post('api/bo/getCardDates', params).then((response) => {
        return response.data;
    });
};
